// import React, { useEffect, useState } from "react";
// import { Modal, Form, Input, InputNumber } from "antd";
// import api from "../../api";
// import { useToast } from "../../components/toast";

// export default function KeywordFormModal({
//   open,
//   editingRow,
//   onClose,
//   onSuccess,
// }) {
//   const [form] = Form.useForm();
//   const [saving, setSaving] = useState(false);
//   const toast = useToast();
//   const isEdit = !!editingRow;

//   useEffect(() => {
//     if (!open) return;
//     if (editingRow) {
//       form.setFieldsValue({
//         key: editingRow.key,
//         label: editingRow.label,
//         value: editingRow.value,
//         sortOrder: editingRow.sortOrder ?? 0,
//       });
//     } else {
//       form.resetFields();
//     }
//   }, [open, editingRow]);

//   const onSave = async () => {
//     try {
//       const values = await form.validateFields();
//       setSaving(true);

//       const payload = {
//         key: values.key.trim(),
//         label: values.label?.trim() || null,
//         value: values.value,
//         sortOrder: values.sortOrder ?? 0,
//       };

//       const res = isEdit
//         ? await api.keywords_update(editingRow.id, payload)
//         : await api.keywords_create(payload);

//       if (res?.status === 200 || res?.status === 201) {
//         toast("Амжилттай хадгаллаа", "success");
//         onSuccess();
//         onClose();
//       } else {
//         toast(res?.data?.message || "Алдаа гарлаа", "error");
//       }
//     } catch {
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Modal
//       open={open}
//       onCancel={onClose}
//       onOk={onSave}
//       confirmLoading={saving}
//       title={isEdit ? "Түлхүүр засах" : "Түлхүүр нэмэх"}
//       okText="Хадгалах"
//       cancelText="Болих"
//       width={440}
//     >
//       <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
//         <Form.Item
//           name="key"
//           label="Түлхүүр"
//           rules={[
//             { required: true, message: "Түлхүүр оруулна уу" },
//             {
//               pattern: /^[a-z0-9_]+$/,
//               message: "Зөвхөн жижиг латин үсэг, тоо, доогуур зураас",
//             },
//           ]}
//           tooltip="Код дотор ашиглагдах нэр. Жишээ: contact_phone, home_stats_users"
//         >
//           <Input
//             placeholder="contact_phone"
//             onChange={(e) =>
//               form.setFieldValue(
//                 "key",
//                 e.target.value.toLowerCase().replace(/\s+/g, "_"),
//               )
//             }
//           />
//         </Form.Item>

//         <Form.Item
//           name="label"
//           label="Тайлбар"
//           tooltip="Админ дээр танихад тусална."
//         >
//           <Input placeholder="Утасны дугаар" />
//         </Form.Item>

//         <Form.Item
//           name="value"
//           label="Утга"
//           rules={[{ required: true, message: "Утга оруулна уу" }]}
//         >
//           <Input.TextArea rows={2} placeholder="7000-1234" />
//         </Form.Item>

//         <Form.Item name="sortOrder" label="Эрэмбэ" initialValue={0}>
//           <InputNumber min={0} style={{ width: "100%" }} />
//         </Form.Item>
//       </Form>
//     </Modal>
//   );
// }

import { useState } from "react";
import { Modal, Form, Input, InputNumber, Select } from "antd";
import api from "../../api";
import { useToast } from "../../components/toast";
import KeywordValueInput from "../../components/keyword/KeywordValueInput";

const KEYWORD_TYPES = [
  { value: "TEXT", label: "Текст" },
  { value: "EDITOR", label: "Editor" },
  { value: "IMAGE", label: "Зураг" },
  { value: "URL", label: "Холбоос" },
];

export default function KeywordFormModal({
  open,
  editingRow,
  onClose,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const toast = useToast();
  const isEdit = !!editingRow;

  const type = Form.useWatch("type", form) ?? editingRow?.type ?? "TEXT";

  const initialValues = editingRow
    ? {
        key: editingRow.key,
        label: editingRow.label,
        type: editingRow.type || "TEXT",
        value: editingRow.value,
        sortOrder: editingRow.sortOrder ?? 0,
      }
    : { type: "TEXT", sortOrder: 0 };

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);

      const payload = {
        key: values.key.trim(),
        label: values.label?.trim() || null,
        type: values.type,
        value: values.value,
        sortOrder: values.sortOrder ?? 0,
      };

      const res = isEdit
        ? await api.keywords_update(editingRow.id, payload)
        : await api.keywords_create(payload);

      if (res?.status === 200 || res?.status === 201) {
        toast("Амжилттай хадгаллаа", "success");
        onSuccess();
        onClose();
      } else {
        toast(res?.data?.message || "Алдаа гарлаа", "error");
      }
    } catch {
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={onSave}
      confirmLoading={saving}
      title={isEdit ? "Түлхүүр засах" : "Түлхүүр нэмэх"}
      okText="Хадгалах"
      cancelText="Болих"
      width={type === "EDITOR" ? 760 : 440}
      destroyOnHidden
    >
      <Form
        key={editingRow?.id ?? "new"}
        form={form}
        layout="vertical"
        preserve={false}
        initialValues={initialValues}
        style={{ marginTop: 16 }}
      >
        <Form.Item
          name="key"
          label="Түлхүүр"
          rules={[
            { required: true, message: "Түлхүүр оруулна уу" },
            {
              pattern: /^[a-z0-9_]+$/,
              message: "Зөвхөн жижиг латин үсэг, тоо, доогуур зураас",
            },
          ]}
        >
          <Input
            placeholder="contact_phone"
            onChange={(e) =>
              form.setFieldValue(
                "key",
                e.target.value.toLowerCase().replace(/\s+/g, "_"),
              )
            }
          />
        </Form.Item>

        <Form.Item
          name="label"
          label="Тайлбар"
          tooltip="Админ дээр танихад тусална."
        >
          <Input placeholder="Утасны дугаар" />
        </Form.Item>

        <Form.Item name="type" label="Төрөл">
          <Select
            options={KEYWORD_TYPES}
            onChange={() => form.setFieldValue("value", undefined)}
          />
        </Form.Item>

        <Form.Item
          name="value"
          label="Утга"
          rules={[{ required: true, message: "Утга оруулна уу" }]}
        >
          <KeywordValueInput type={type} />
        </Form.Item>

        <Form.Item name="sortOrder" label="Эрэмбэ">
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
